import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { ChainWideMerakisComponent } from '@app/features/merakis/modules/chain-wide-merakis/chain-wide-merakis.component';
import { Authority } from '@app/shared/utils/enums';

export const chainWideMerakisRoutes: Routes = [
    {
        path: 'chain-wide-merakis',
        children: [
            {
                path: '',
                component: ChainWideMerakisComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]